<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="elevation-10">
          <v-card-actions>
            <v-row>
              <v-col
                cols="4"
              >
                <v-text-field
                  v-model="search"
                  placeholder="Key in task category here"
                  append-icon="search"
                  label="Search task category"
                  hide-no-data
                  hide-selected
                  clearable
                />
              </v-col>
              <v-col
                cols="4"
              >
                <v-select
                  v-model="statusFilter"
                  :items="items"
                  item-text="state"
                  item-value="value"
                  label="Task Category's Status"
                  placeholder="Active / Deleted"
                />
              </v-col>
              <v-col
                cols="2"
                offset-md="2"
              >
                <setup-tasks-categories-dialog-create
                  @created="loadTaskCategories"
                />
              </v-col>
            </v-row>
          </v-card-actions>
          <v-data-table
            :loading="tableLoading"
            :headers="headers"
            :items="filteredTaskCategories"
            :search="search"
          >
            <template v-slot:item.name="{ item }">
              <div>
                <span>
                  {{ item.name }}
                </span>
              </div>
            </template>
            <template v-slot:item.action="{ item }">
              <span v-if="statusFilter">
                <setup-tasks-categories-dialog-edit
                  :task-category="item"
                  @updated="loadTaskCategories"
                />
                <span class="mx-1" />
                <setup-tasks-categories-dialog-delete
                  :task-category="item"
                  @deleted="loadTaskCategories"
                />
              </span>
              <span v-else>
                <setup-tasks-categories-dialog-restore
                  :task-category="item"
                  @restored="loadTaskCategories"
                />
              </span>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    components: {
      SetupTasksCategoriesDialogCreate: () => import('@/components/setup/tasks/categories/DialogCreate'),
      SetupTasksCategoriesDialogEdit: () => import('@/components/setup/tasks/categories/DialogEdit'),
      SetupTasksCategoriesDialogDelete: () => import('@/components/setup/tasks/categories/DialogDelete'),
      SetupTasksCategoriesDialogRestore: () => import('@/components/setup/tasks/categories/DialogRestore'),
    },
    metaInfo () {
      return {
        title: 'Task Categories',
      }
    },
    data () {
      return {
        taskCategories: [],
        trashedTaskCategories: [],
        search: '',
        tableLoading: true,
        statusFilter: { state: 'Active', value: true },
        items: [
          { state: 'Active', value: true },
          { state: 'Deleted', value: false },
        ],
        headers: [
          {
            text: 'Task Category',
            align: 'left',
            value: 'name',
          },
          {
            text: 'Actions',
            sortable: false,
            value: 'action',
          },
        ],
      }
    },
    computed: {
      filteredTaskCategories () {
        return this.statusFilter ? this.taskCategories : this.trashedTaskCategories
      },
    },
    created () {
      this.loadTaskCategories()
    },
    methods: {
      loadTaskCategories () {
        this.tableLoading = true

        Promise.all([
          this.$api.taskCategories().list(),
          this.$api.taskCategories().listTrashed(),
        ])
          .then(([taskCategories, trashedTaskCategories]) => {
            this.taskCategories = taskCategories.data
            this.trashedTaskCategories = trashedTaskCategories.data
            this.tableLoading = false
          })
      },
    },
  }
</script>
